<template>
  <load-content :loading="loading || aiProviderIsBusy">

    <div class="card">
      <div class="add-btn-container">
        <button class="add-btn btn btn-sm btn-carma" @click="onOpen">
          <i class="fas fa-plus-circle btn-primary"></i>
        </button>
      </div>
      <div class="carma-ai-datatable">
        <datatable 
        ref="table" 
        :data="tabledata"
      />
      </div>
    </div>
    <app-side-panel v-if="showCreate" :onClose="onCancel">
      <form v-if="errors" action="">
        <ul  class="error-msgs">
          <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
        </ul>
      </form>
      <form-renderer
        id="ai-coding-config"
        :model="promptModel"
        :fields="fields"
        :showSubmit="true"
        :loading="isAiCodingBusy"
        formWrapperClass="d-grid gap-3"
        @updateModel="updatePromptModel"
        :disableSubmit="saving"
        @onSave="onSave"
      />
      <span class="d-block mt-3">{{$t('ai_coding.prompt_note')}}</span>
      <hr>
      <div class="flex-2to1 flex-col mt50">
        <div>
          <form-renderer
            id="ai-coding-test"
            :key="renderKey"
            submitButtonLabel="ai_coding.actions.test"
            :submitButtonClass="`btn-default btn-square mt10 ${testing  || (!sidePanelTestModel.article_id && !sidePanelTestModel.text)? 'disabled' : ''}`"
            :model="sidePanelTestModel"
            :fields="testFields().filter(f => f.key !== 'ai_model_id')"
            :loading="isAiCodingTestBusy"
            @updateModel="model => updateTestModel(model, 'sidePanelTestModel')"
            @onSave="() => onTest(sidePanelTestModel, 'sidePanelResult')"
          />
          <ai-test-images :model="sidePanelTestModel" :handleFileUpload="handleFileUpload" :removeImage="removeImage" />
        </div>
        <div class="textarea-hmax pb50 d-flex flex-col">
          <label for="sidePanelResult">&nbsp;</label>
          <textarea name="sidePanelResult" id="sidePanelResult" :placeholder="$i18n.t('ai_coding.fields.results')" class="input-ui app-input" readonly v-model="sidePanelResult[0].completion" :style="{ height: '35vh' }"></textarea>
          <span v-if="sidePanelResultError">{{ sidePanelResultError }}</span>
          <div v-if="sidePanelResult[0].organizationTagMap && Object.keys(sidePanelResult[0].organizationTagMap).length > 0">
            <div v-for="(value, key) in sidePanelResult[0].organizationTagMap" :key="key">
              <div v-if="key === 'Unspecified'"><strong>{{$i18n.t('ai_coding.message.unspecified_organization')}}</strong></div>
              <div v-if="key !== 'Unspecified'"><strong>{{ key }} </strong>{{$i18n.t('ai_coding.message.matched_tags')}}: <strong>{{ value.matchedTags }}</strong></div>
              <div v-if="value.unmatchedTags">
                <span>{{$i18n.t('ai_coding.message.unmatched_tags')}}:</span>
                <strong v-for="(tag, index) in value.unmatchedTags.split(', ')" :key="index">
                  {{ tag }}{{ index !== value.unmatchedTags.split(', ').length - 1 ? ', ' : '' }}
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-side-panel>
    <span>{{$t('ai_coding.prompt_note')}}</span>
    
    <hr>
    <div class="flex-1to1 mt50">
      <div>
        <form-renderer
          id="ai-coding-test"
          submitButtonLabel="ai_coding.actions.test"
          :submitButtonClass="`btn-default btn-square mt10 ${testing || (!testModel.article_id && !testModel.text) ? 'disabled' : ''}`"
          :model="testModel"
          :fields="testFields()"
          :loading="isAiCodingTestBusy"
          @updateModel="model => updateTestModel(model, 'testModel')"
          @onSave="() => onTest(testModel, 'result')"
        />
        <ai-test-images :model="testModel" :handleFileUpload="handleFileUpload" :removeImage="removeImage" />
      </div>
      <div class="textarea-hmax pb50 d-flex flex-col pl20">
        <div class="d-flex justify-content-between align-items-center">
          <label for="result">{{result[resultIndex].prompt_key || ''}} {{result[resultIndex].name}}</label>
          <div class="btn-container d-flex justify-content-end">
            <button class="prev-btn btn btn-carma w-auto mr-2" :class="{ 'disabled': resultIndex === 0 || !result[resultIndex].prompt_key}" @click="handlePrev" :disabled="resultIndex === 0 || !result[resultIndex].prompt_key"><i class="fa fa-chevron-circle-left fa-xl" aria-hidden="true"></i></button>
            <button class="next-btn btn btn-carma w-auto" :class="{ 'disabled': resultIndex === result.length-1 || !result[resultIndex].prompt_key}" @click="handleNext" :disabled="resultIndex === result.length-1 || !result[resultIndex].prompt_key"><i class="fa fa-chevron-circle-right fa-xl" aria-hidden="true"></i></button>
          </div>
        </div>
        <textarea name="result" id="result" :placeholder="$i18n.t('ai_coding.fields.results')" class="input-ui app-input" readonly v-model="result[resultIndex].completion" :style="{ height: '35vh' }"></textarea>
        <span v-if="resultError">{{ resultError }}</span>
        <div v-if="result[resultIndex].organizationTagMap && Object.keys(result[resultIndex].organizationTagMap).length > 0">
          <div v-for="(value, key) in result[resultIndex].organizationTagMap" :key="key">
            <div v-if="key === 'Unspecified'"><strong>{{$i18n.t('ai_coding.message.unspecified_organization')}}</strong></div>
            <div v-if="key !== 'Unspecified'"><strong>{{ key }} </strong>{{$i18n.t('ai_coding.message.matched_tags')}}: <strong>{{ value.matchedTags }}</strong></div>
            <div v-if="value.unmatchedTags">
              <span>{{$i18n.t('ai_coding.message.unmatched_tags')}}:</span>
              <strong v-for="(tag, index) in value.unmatchedTags.split(', ')" :key="index">
                {{ tag }}{{ index !== value.unmatchedTags.split(', ').length - 1 ? ', ' : '' }}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirmation-modal v-if="showConfirmation"
      :headerText="this.$t(`carma_ai.modal.title`)"
      :message="this.$t(`carma_ai.modal.message`)"
      :showDeleteButton="false"
      :force-tab-index="true"
      @confirmAction="(e) => onDelete()"
      @cancelAction="() => { showConfirmation = false; }" 
    />
  </load-content>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { FIELD_TYPE, VALIDATIONS } from '../../config/const';
import FormHelper from '../../helpers/form';
import FormRenderer from '../form-renderer';
import LoadContent from '../load-content';
import Datatable from '@/components/datatable';
import Sidepanel from '@/components/side-panel.vue';
import ConfirmationModal from '@/components/confirmation-modal';
import AiTestImages from './ai-test-images.vue'

const defaultModel = 11;

export default {
  components: {
    FormRenderer,
    LoadContent,
    Datatable,
    ConfirmationModal,
    'app-side-panel': Sidepanel,
    'ai-test-images': AiTestImages
  },

  mounted () {
    this.loading = true;
    Promise.all([
      this.getAiProviders({ projectId: this.projectId, scope: 'ai_coding' }),
      this.fetchPrompt(),
      this.getUserPreferences({ name: 'ai_coding_test_default_models', projectId: this.projectId })
    ]).then(() => {
      this.loading = false;
    });
  },

  data () {
    const provider = this.findModelProvider(defaultModel);
    return {
      loading: false,
      saving: false,
      testing: false,
      promptModel: {
        id: null,
        provider: provider,
        ai_model_id: defaultModel,
        prompt: null,
        name: '',
        allow_ai: false,
        analyze_images: false
      },
      testModel: {
        article_id: null,
        text: null,
        images: []
      },
      sidePanelTestModel: {
        article_id: null,
        text: null,
        images: []
      },
      result: [{
        completion: null,
        organizationTagMap: null,
        error: null,
        prompt_key: 0
      }],
      sidePanelResult: [{
        completion: null,
        organizationTagMap: null,
        error: null
      }],
      resultIndex: 0,
      models: [],
      errors: null,
      tableBody: [],
      showCreate: false,
      modelOptions1: [],
      renderKey: 0,
      showConfirmation: false,
      modelsSelectOptions: [],
    }
  },

  computed: {
    ...mapState({
      aiCodingData: state => state?.aiCoding?.aiCoding?.data,
      isAiCodingBusy: state => state?.aiCoding?.aiCoding?.isBusy,
      isAiCodingTestBusy: state => state?.aiCoding?.aiCoding?.isTestBusy,
      aiProviders: state => state.carmaAi?.carmaAi?.aiProviders?.data || [],
      aiProviderIsBusy: state => state.carmaAi?.carmaAi?.aiProviderIsBusy,
      preferences: state => state?.user?.preferences
    }),
    projectId () {
      return this.$route.params.project_uid;
    },

    providerOptions () {
      return Array.from(
        new Set(this.aiProviders.map(p => p.provider))
      ).map(p => ({ value: p, label: p }));
    },

    modelOptions () {
      const provider = this.promptModel?.provider || this.providerOptions?.[0]?.value;
      return this.aiProviders.filter(m => m.provider === provider).map(m => ({ value: m.model_id, label: m.model }));
    },

    resultError() {
      if (this.result?.[this.resultIndex]?.error) {
        return this.result?.[this.resultIndex]?.error === "malformed_json" ? this.$i18n.t('ai_coding.message.malformed_json') : this.result?.[this.resultIndex]?.error;
      }
      return null;
    },
    sidePanelResultError() {
      if (this.sidePanelResult?.[0]?.error) {
        return this.sidePanelResult?.[0]?.error === "malformed_json" ? this.$i18n.t('ai_coding.message.malformed_json') : this.sidePanelResult?.[0]?.error;
      }
      return null;
    },
    tabledata () {
      return {
        body: this.tableBody,
        columns: [
        {
          key: 'prompt_key',
          label: this.$t('ai_coding.table.sr_no'),
          render: (row) => {
            return <span>{row.prompt_key}</span>
          }
        },
        {
          key: 'allow_ai',
          label: this.$t('ai_coding.table.allow_ai'),
          render: (row) => {
            return <span>{row.allow_ai && <i class="fa fa-check text-success" aria-hidden="true"></i> || <i class="fa fa-times text-danger" aria-hidden="true"></i>}</span>
          }
        },
        {
          key: 'name',
          label: this.$t('ai_coding.table.name'),
          render: (row) => {
            return  <span>{row.name}</span>;
          }
        },
        {
          key: 'ai_model_id',
          label: this.$t('ai_coding.table.model'),
          render: (row) => {
            return  <span>{this.getModelName(row.ai_model_id)}</span>;
          }
        },
        {
          key: 'prompt',
          label: this.$t('ai_coding.table.prompt'),
          render: (row) => {
            const promptText = row?.prompt || '';  
            return <span>{promptText.substring(0, 250)}{promptText.length > 250 ? '...' : ''}</span>;
          },
          style: 'min-width: 50%;'
        },
        {
          key: "",
          label: "",
          render: (row) => {
            return (
              <span class="d-flex">
                <button onClick={() => this.handleEdit(row)} class="btn btn-sm text-info bg-transparent mr-2">
                  <i class="fas fa-edit"></i>
                </button>
                <button onClick={() => this.handleDelete(row.id)} class="btn btn-sm bg-transparent text-danger">
                  <i class="fas fa-trash"></i>
                </button>
              </span>
            );
          },
        }],
        fixedColumns: {
          enabled: true,
          fixedColumnsLeft: 0,
          widths: [2, 10, 10 , 10 , 250 ,2]
        },
        reorderRows: {
          enabled: true,
          onReorder: this.onReorderPrompts
        }
      }
    },

    fields () {
      return [
        {
          key: 'name',
          id: 'name',
          name: 'name',
          label: this.$t('ai_coding.fields.name'),
          type: FIELD_TYPE.INPUT,
          validate: [VALIDATIONS.REQUIRED],
        },
        {
          key: 'allow_ai',
          id: 'allow_ai',
          name: 'allow_ai',
          label: this.$t('ai_coding.fields.allow_ai'),
          type: FIELD_TYPE.TOGGLE,
          translate_label_tooltip: 'ai_coding.message.allow_ai_toolip',
          style: 'grid-column: 1'
        },
        {
          key: 'analyze_images',
          id: 'analyze_images',
          name: 'analyze_images',
          label: this.$t('ai_coding.fields.analyze_images'),
          type: FIELD_TYPE.TOGGLE,
        },
        {
          key: 'provider',
          id: 'provider',
          name: 'provider',
          searchable: true,
          label: this.$t('ai_coding.fields.provider'),
          type: FIELD_TYPE.SELECT,
          options: this.providerOptions,
          allowEmpty: false
        },
        {
          key: 'ai_model_id',
          id: 'ai_model_id',
          name: 'ai_model_id',
          searchable: true,
          label: this.$t('ai_coding.fields.model'),
          type: FIELD_TYPE.SELECT,
          options: this.modelOptions,
          allowEmpty: true,
          validate: [VALIDATIONS.REQUIRED],
          translate_label_tooltip: 'ai_coding.message.model_tooltip',
          helperText: this.supportImageHelperText()
        },
        {
          key: 'prompt',
          id: 'prompt',
          name: 'prompt',
          label: this.$i18n.t('ai_coding.fields.prompt'),
          type: FIELD_TYPE.TEXTAREA,
          validate: [VALIDATIONS.REQUIRED],
          customClass: '',
          inputWrapperClass: 'h-500',
          style: 'grid-column: 1 / span 2'
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      getPrompt: 'aiCoding/getPrompt',
      createPrompt: 'aiCoding/createPrompt',
      updatePrompt: 'aiCoding/updatePrompt',
      deletePrompt: 'aiCoding/deletePrompt',
      runTest: 'aiCoding/runTest',
      getAiProviders: "carmaAi/getAiProviders",
      getUserPreferences: 'user/getUserPreferences',
      updateUserPreferences: 'user/updateUserPreferences',
      updatePromptsOrder: 'aiCoding/updatePromptsOrder'
    }),

    onSaveSelectedModels (value) {
      if (value) {
        this.updateUserPreferences({ name: 'ai_coding_test_default_models', projectId: this.projectId, settings: { value } }).then(r => {
          this.$notify({
            group: 'store_notifications',
            type: 'success',
            text: this.$t('ai_coding.message.default_models'),
          });
        });
      }
    },

    testFields () {
      return [
        {
          key: 'ai_model_id',
          id: 'ai_model_id',
          name: 'model_ids',
          searchable: true,
          multiple: true,
          label: this.$t('ai_coding.fields.model'),
          type: FIELD_TYPE.SELECT,
          options: this.modelsSelectOptions,
          customClass: 'mr10',
          allowEmpty: true,
          validate: [VALIDATIONS.REQUIRED],
          selectAllTooltipMessage: this.$t('form.tooltip.select_all'),
          clearAllTooltipMessage: this.$t('form.tooltip.clear_selection'),
          style: 'min-width: 48.5%',
          translate_label_tooltip: 'ai_coding.message.model_tooltip',
          events: {
            saveSelection: this.onSaveSelectedModels
          }
        },
        {
          key: 'article_id',
          id: 'article_id',
          name: 'article_id',
          label: this.$i18n.t('ai_coding.fields.article_id'),
          type: FIELD_TYPE.INPUT,
          inputType: 'number',
          translate_label: 'ai_coding.fields.article_id',
          style: 'flex: 1 1 100%'
        },
        {
          key: 'text',
          id: 'text',
          name: 'text',
          label: this.$i18n.t('ai_coding.fields.text'),
          type: FIELD_TYPE.TEXTAREA,
          translate_label: 'ai_coding.fields.text',
          style: 'flex: 1 1 100%',
          inputWrapperClass: 'textarea-h100'
        }
      ]
    },

    handleModelOptions(models = this.models) {
      this.modelsSelectOptions = models?.map(m => ({ label: m?.prompt_key + ' ' + m?.name , value: m?.id }));
    },

    promptModelReset(){
      const provider = this.findModelProvider(defaultModel);

      this.promptModel = {
        id: null,
        provider: provider,
        ai_model_id: defaultModel,
        prompt: null,
        name: '',
        allow_ai: false,
        analyze_images: false
      }
    },

    onOpen () {
      this.showCreate = true;
      this.promptModelReset();
    },
    onCancel () {
      this.showCreate = false;
    },

    handleEdit(r){
      const model = {
          ...this.promptModel,
          id: r.id,
          name: r.name,
          allow_ai: r.allow_ai,
          prompt: r.prompt,
          ai_model_id: r.ai_model_id || defaultModel,
          analyze_images: r.analyze_images
        }
        this.sidePanelTestModel = {
          article_id: null,
          text: null,
          images: []
        }

        let provider;
        if (r.ai_model_id) {
          provider = this.findModelProvider(r.ai_model_id);
          model.provider = provider;
        }
      this.promptModel = model;
      this.showCreate = true;
    },

    onDelete(){
      if(!this.promptId) return;
      this.deletePrompt({ projectId: this.projectId, promptId: this.promptId })?.then(() => {
        this.tableBody = this.tableBody?.filter(p => p?.id !== this.promptId);
        this.showConfirmation = false;
      });
    },

    handleDelete(id){
      this.showConfirmation = true;
      this.promptId = id;
    },

    findModelProvider (model_id) {
      return this.aiProviders?.find(item => item.model_id === model_id)?.provider;
    },

    fetchPrompt () {
      this.getPrompt({ projectId: this.projectId }).then(r => {
        //
        const models = []
        for(let i=0; i< r.length; i++){
          const model = {
            ...this.promptModel,
            id: r[i]?.id,
            name: r[i].name,
            allow_ai: r[i].allow_ai,
            prompt_key: r[i].prompt_key,
            prompt: r[i].prompt,
            ai_model_id: r[i].ai_model_id,
            analyze_images: r[i].analyze_images
          }

          let provider;
          if (r[i].ai_model_id) {
            provider = this.findModelProvider(r[i].ai_model_id);
            model.provider = provider;
          }
          models.push(model);
        }

        this.tableBody = models;
        this.models = models;
        this.handleModelOptions(models);
      });
    },

    onSave () {
      this.errors = null;
      if (this.saving) return;
      this.saving = true;
      const form = this.fields.reduce((acc, item) => ({ ...acc, [item.key]: { ...item, value: this.promptModel[item.key] } }), {});
      const errors = FormHelper.validateForm(form);

      if (errors.length > 0) {
        this.errors = errors;
        this.saving = false;
      } else {
        if(this.promptModel?.id) {
          this.updatePrompt({ projectId: this.projectId, data: this.promptModel, promptId: this.promptModel?.id }).then(data => {
            this.tableBody = this.tableBody.map(d => d?.id === data?.id && (d = data) && d || d);
            this.modelsSelectOptions = this.modelsSelectOptions?.map(m => m?.value === data?.id && (m = { label: data?.prompt_key + ' ' + data?.name , value: data?.id }) && m || m);
          }).finally(() => this.saving = false);
        }
        else {
          this.createPrompt({ projectId: this.projectId, data: this.promptModel }).then(data => {
            this.promptModel.id = data.id;
            this.tableBody.push(data);
            this.onCancel();
          }).finally(() => {
            this.handleEdit(this.promptModel);
            this.saving = false;
          });
        }
      }
    },

    onTest(model = this.testModel, result = 'result') {
      this.testing = true;
      this[result][0].completion = this.$i18n.t('ai_coding.message.testing');
         this.runTest({ projectId: this.projectId, data: { ...model, ...this.promptModel } }).then(r => {
          this[result] = r;
        })
        .finally(() => {
          this.testing = false;
        });
    },

    updatePromptModel (model, field) {
      this.$set(this.promptModel, field.name, model[field.name]);
      if (field.name === 'provider') {
        this.$set(this.promptModel, 'model', null);
      }
    },

    updateTestModel (model, modelName = 'testModel') {
      this[modelName] = { ...model };
    },

    handlePrev() {
      this.resultIndex -= 1;
    },

    handleNext() {
      this.resultIndex += 1;
    },

    handleFileUpload(event, model= this.testModel) {
      const files = event.target.files;
      if (!files.length) return;
      const images = []; 
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          const contentType = file.type;
          const base64String = e.target.result;
          const size = (base64String.length * 3) / 4;
          images.push({url: base64String, content_type: contentType, size});
          if (images.length === files.length) {
            model.images = [...model.images, ...images];
            this.renderKey += 1;
            event.target.value = '';
          }
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage(index, model= this.testModel) {
      model.images.splice(index, 1);
    },
    supportImageHelperText () {
      const allowsImages = this.aiProviders?.find(item => item.model_id === this.promptModel.ai_model_id)?.allows_images;
      return this.promptModel.ai_model_id && this.promptModel.analyze_images && !allowsImages && this.$t('carma_ai.messages.images_not_supported')
    },

    onReorderPrompts (prompts) {
      const order = prompts.map(p => p.id);
      this.updatePromptsOrder({ projectId: this.projectId, order });
    },

    getModelName(model_id) {
      return this.aiProviders.find(item => item.model_id === model_id)?.model;
    }
  },

  watch: {
    'preferences.ai_coding_test_default_models': {
      handler(value) {
        if (Array.isArray(value?.value)) {
          const models = value.value;
          this.modelsSelectOptions = [...this.modelsSelectOptions, ...models].filter((dt, i, arr) => arr.findIndex(t => t.value === dt.value) === i);
          this.updateTestModel({ ...this.testModel, model_ids: models.map(dt => dt.value) }, 'testModel');
        }
      },
      deep: true
    }
  }
}
</script>

<style>
  .h-500{
    & textarea{
      min-height: 31.25rem;
    }
  }
  .h-250{
    & textarea{
      min-height: 15.62rem;
    }
  }
  .prev-btn, .next-btn{
    height: 30px!important;
    line-height: 30px!important;
    padding: 0 10px!important;
  }
  .add-btn-container{
    & .btn-carma{
      width: 2.2rem;
      margin-bottom: 1rem;
    }
  }
  .carma-ai-datatable{
    & .table-wrapper.table-wrapper--overflow {
      height: auto !important;
      max-height: 33rem !important;
      overflow-y: auto;
    }
  }
  .side-panel #ai-coding-config{
    & .side-panel-toggle{
      & #allow_ai-wrapper, & .toggle-wrapper label{
        float: right;
      }
    }

    .d-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
</style>